// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Promise from 'promise-polyfill'
// To add to window
if (!window.Promise) {
  window.Promise = Promise
}
import Vue from 'vue'
import App from './App'
import './filters'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'normalize.css'
import 'font-awesome/css/font-awesome.min.css'
import 'element-ui/lib/theme-default/index.css'
import httpPlugin from './libs/$http'
import momentPlugin from './libs/$moment'

Vue.use(ElementUI)
Vue.use(httpPlugin)
Vue.use(momentPlugin)
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js